module.exports = __webpack_public_path__ + "img/distribute02.fba17a4d.png";